import React, { useEffect, useRef, useState } from "react";
import DonutChart from "../../../admin/components/Charts/DonutChart";
import DimenstionFutureChart from "../../../admin/components/Charts/customerDimensionFuture/DimensionFutureChart";

const GraphDetail = () => {
  return (
    <div className="overall-result">
      <div className="overall-result-content">

        <div className="row">
          <div className="col-md-12 mb-4">
            <div class="accordion accordion-flush "  >
              <div class="accordion-item chart-container">
                <div className="  graph1">
                  <div className="d-flex justify-content-between">
                    <h2 class="accordion-header " id="flush-headingOne"><button class="accordion-button collapsed" type="button" > Overall Participation
                    </button>
                    </h2>
                    <div className="d-flex align-items-center justify-content-center resulticon_content">
                      ssss
                    </div>
                  </div>
                </div>
                <div id="flush-collapseOne" class="accordion-collapse collapse show" >

                  <div class="accordion-body chart1" data-heading="Overall Participation ">

                    <DimenstionFutureChart selectedCompanyId="67a301fb3b9fe957d968c42d" graphName="CustomerDimensionFuture" remarkform="true"
                    />
                  </div>

                  <div className="indivisualresult-btn mb-3 ">
                    <div className="d-flex justify-content-center">
                      <div className="exportpdf-btnsec ">
                        <button className="exportpdfbtn cursor-pointer" >
                          Export PDF
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  );
};

export default GraphDetail;
